/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { gql } from '@apollo/client';
import { GRAPHQL_ENV } from '..';

/**
 * @param {string} brand - baskets or berries
 * @param {string} partNumber - SKU to be fetched
 */

const findProductPageByPartNumberPersonalize = (brand, partNumber, pricingOptions = null) => (

    // very important for serializing. add space between bracket and query name + add typenames to query
    gql`query ProductPageQuery${!brand && !partNumber ? `($brand: String!, $partNumber: String! ${pricingOptions ? ', $pricingOptions: PricingOptions' : ''})` : ''}{ findProductPageByPartNumber(brand: ${!brand ? '$brand' : `"${brand}"`}, environment: "${GRAPHQL_ENV}", partNumber: ${!brand ? '$partNumber' : `"${partNumber}"`} ${pricingOptions ? ', pricingOptions: $pricingOptions' : ''}) {
            product {
                displayDeliveryCalendar
                isPersonalizable
            __typename
            }
        __typename
        }
    }
`
);
export default findProductPageByPartNumberPersonalize;
